import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';
import { ChangeLabel, ParticipantDisplay } from '../../models/annual-enrollment-models';
import { AnnualEnrollmentProps } from '../../../arc/models/arc-epi-props';
import { selectedReviewItemStyles } from '../../../../global/constants/theme/styles/components/selected-review-item';
import { getChangeLabelText } from '../../helpers/annual-enrollment-helpers';

interface ParticipantReviewProps {
    info: ParticipantDisplay;
    annualEnrollmentProps: AnnualEnrollmentProps;
}
export function ParticipantReviewDisplay(props: ParticipantReviewProps) {
    const { info, annualEnrollmentProps } = props;
    if (!info || (!info.currentlyEnrolled && info?.changeLabel === ChangeLabel.None)) return null;

    return (
        <div className='selected-review-item-inner'>

            <div className='selected-review-item-content'>
                {(info.changeLabel === ChangeLabel.Added || (info.currentlyEnrolled && info?.changeLabel === ChangeLabel.None)) ? <CheckIcon className='selected-review-item-icon added' /> : <RemoveIcon className='selected-review-item-icon removed' />}

                <div>
                    <p><strong>{info.name}</strong></p>
                    <p className='input-caption'>{info.relationshipLabel}</p>
                </div>
            </div>
            <p className={`selected-review-item-subtext ${(info.changeLabel === ChangeLabel.Added || (info.currentlyEnrolled && info?.changeLabel === ChangeLabel.None)) ? 'green-text' : 'red-text'}`}><strong>{getChangeLabelText(info.changeLabel, annualEnrollmentProps)}</strong></p>
        </div>
    );
}

interface Props {
    label: string;
    annualEnrollmentProps: AnnualEnrollmentProps;
    items: ParticipantDisplay[];
}
export function ParticipantDisplayGroup(props: Props) {
    const { label, annualEnrollmentProps, items } = props;
    const classes = selectedReviewItemStyles();

    return (
        <div className={`divider-section-item ${classes.selectedReviewItem}`}>
            <h4 className='selected-review-item-header'>{label}</h4>
            {items?.map(p =>
                <ParticipantReviewDisplay
                    key={p?.name}
                    info={p}
                    annualEnrollmentProps={annualEnrollmentProps}
                />,
            )}



        </div>
    );
}

